import { internalErrorMessage } from '../actions/messages.js'
import { unAuthorizedAPIError, forbiddenAPIError } from '../actions/api.js'

export const callAPIMiddleware = store => next => action => {
  const { dispatch } = store

  if (!action || Object.prototype.toString.call(action) !== '[object Object]') {
    throw new Error('Expected an object ’action’')
  }

  const { promise, types, ...rest } = action

  // simple action
  if (!promise) {
    return next(action)
  }

  if (!types || !Array.isArray(types) || types.length !== 3 || !types.every(type => typeof type === 'string')) {
    throw new Error('Expected an array of three string types')
  }

  if (typeof promise !== 'function') {
    throw new Error("Expected a function 'promise'")
  }

  const [REQUEST_TYPE, SUCCESS_TYPE, FAILURE_TYPE] = types

  // dispatch start request
  next({ ...rest, type: REQUEST_TYPE })

  return promise(dispatch)
    .then(response => next({ ...rest, response, type: SUCCESS_TYPE, status: { isSuccess: true, isFailure: false } })) // dispatch success event
    .catch(({ statusCode, error, url = '' } = {}) => {
      // internal errors
      if (statusCode && (statusCode > 422 || statusCode === 405)) {
        return next(internalErrorMessage())
      }

      if (statusCode && statusCode === 403) {
        return next(
          forbiddenAPIError({
            ...rest,
            statusCode,
            error,
            type: FAILURE_TYPE,
            status: { isSuccess: false, isFailure: true }
          })
        )
      }

      if (statusCode && statusCode === 401) {
        return next(
          unAuthorizedAPIError({
            ...rest,
            statusCode,
            error,
            url,
            type: FAILURE_TYPE,
            status: { isSuccess: false, isFailure: true }
          })
        )
      }

      // dispatch failure event
      return next({ ...rest, statusCode, error, type: FAILURE_TYPE, status: { isSuccess: false, isFailure: true } })
    })
}
